import React from 'react';

export default function CTAButton({ className = '', text = 'Start Now' }) {
  return (
    <a
      href="https://link.ajedolabomi.com/free-stocks"
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-block bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-4 px-10 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 text-lg text-center ${className}`}
    >
      {text}
    </a>
  );
}